/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { getLoader } from '../_common/utils'

import { exchangeActions } from '../_actions'
import AddExchangeComponent from '../components/AddExchangeComponent'
//import SidebarComponent from '../components/SidebarComponent'
import { Growl } from 'primereact/growl'
import { messageConstants } from '../_constants'


function AddExchangeContainer({ addExchange, getExchangeById, exchangeEntry, isLoading, updateExchange, clearAllMessages, addExchangeMessage, updateExchangeMessage }) {
  const { id } = useParams()
  const history = useHistory()
  const growl = useRef()
  useEffect(() => {
    if (addExchangeMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Exchange Added Successfully' })
      setTimeout(function () { clearAllMessages(); history.push('/dashboard/exchange-list') }, 500)
    }
    // eslint-disable-next-line no-empty
    else if (addExchangeMessage === 'exchangename-exist' || updateExchangeMessage === 'exchangename-exist') {
      growl.current.show({ severity: messageConstants.sevirity.error, summary: '', detail: 'Exchange Name already exist' })
      setTimeout(function () { clearAllMessages() }, 500)
    }
    if (updateExchangeMessage === 'success') {
      growl.current.show({ severity: 'success', summary: '', detail: 'Exchange Updated Successfully' })
      setTimeout(function () { clearAllMessages(); history.push('/dashboard/exchange-list') }, 500)
    }
  }, [addExchangeMessage, updateExchangeMessage, exchangeEntry])
  return (
    <div className="p-grid pageWrapper">
      {isLoading ? getLoader() : ''}
      <Growl ref={growl} />
      <AddExchangeComponent
        addExchange={addExchange}
        getExchangeById={getExchangeById}
        exchangeEntry={exchangeEntry}
        isLoading={isLoading}
        updateExchange={updateExchange}
        exchangeId={parseInt(id)}
      />
    </div>
  )
}
const mapStateToProps = state => {
  return {
    exchangeEntry: state.exchange.exchangeEntry ? state.exchange.exchangeEntry : null,
    isLoading: state.exchange.isLoading,
    addExchangeMessage: state.exchange.addExchangeMessage,
    updateExchangeMessage: state.exchange.updateExchangeMessage
  }
}
AddExchangeContainer.propTypes = {
  addExchange: PropTypes.func,
  getExchangeById: PropTypes.func,
  exchangeEntry: PropTypes.object,
  isLoading: PropTypes.bool,
  updateExchange: PropTypes.func,
  clearAllMessages: PropTypes.func,
  addExchangeMessage: PropTypes.string,
  updateExchangeMessage: PropTypes.string,
  exchangeId: PropTypes.number
}

const mapDispatchToProps = (dispatch) => {
  return {
    addExchange: (exchange) => dispatch(exchangeActions.addExchange(exchange)),
    getExchangeById: (id) => dispatch(exchangeActions.getExchangeById(id)),
    updateExchange: (exchange, id) => dispatch(exchangeActions.updateExchange(exchange, id)),
    clearAllMessages: () => dispatch(exchangeActions.clearAllMessages())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddExchangeContainer)
